<div class="td-wb-markets-range-indicator">
  <!--Ranges can be displayed as Days or Years or no label-->
  @if (label !== undefined) {
    <div class="td-wb-markets-range-indicator--padding-bottom"
         [textContent]="'tdWb.rangeIndicator.' + label | tdWbTranslate">
    </div>
  }
  <div class="td-wb-markets-range-indicator__bar">
    <!--This is the green bar that expands and shrinks to indicate the value in relation to min max-->
    <div class="td-wb-markets-range-indicator__fill"
         [style.width.%]="width"></div>
  </div>
  <div class="td-wb-markets-range-indicator__data">
    <!--Minimum value on the left-->
    @if (min !== undefined) {
      <div class="td-wb-left"
           [textContent]="min | tdWbCurrency: { format: 'c2' }">
      </div>
    }
    <!--Maximum value on the right-->
    @if (max !== undefined) {
      <div class="td-wb-right"
           [textContent]="max | tdWbCurrency: { format: 'c2' }">
      </div>
    }
  </div>
</div>
